import React, { useState, useCallback, useEffect } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  Outlet,
} from "react-router-dom";

//import Home1 from "./Components/HomeNew/Home1";
import Navbar from "./Components/Navbar";
import Dashboard from "./Components/Dashboard/Dashboard";
import Dashboard2 from "./Components/Dashboard2";

import CategoryManager from "./Components/CategoryManager";
import Registration from "./Components/Registration/Registration";

import Login from "./Components/Login";
import Sidebar from "./Components/Sidebar";
import ProtectedRoute from "./Components/ProtectedRoute";

import "bootstrap/dist/css/bootstrap.min.css";
import "../src/App.css"; // Optional: Add global styles if needed
import Invitation from "./Components/Invitation";
import Group from "./Components/UserGroup";
import UsrMap from "./Components/UserMapping";
import RoleMap from "./Components/RoleMapping";
import VCard from "./Components/Vendor_CardView";
import VStatus from "./Components/Vendor_Status";
import Cardscan from "./Components/Card_Scan";
import BussinessC from "./Components/Bussiness_Card";
import ReligionManager from "./Components/ReligionManager";
import RegionManager from "./Components/RegionManager";
import HolidayManager from "./Components/HolidayManager";
import TemplateMaster from "./Components/TemplateMaster";
import CustomMail from "./Components/CustomMail";

import EventManager from "./Components/EventManager";
import VendorApprovalStatus from "./Components/VendorApprovalStatus";
import PrivateUserMaster from "./Components/PrivateUserMaster";
import BusinessCardReport from "./Components/Business_CardReport";

import NotFound from "./Components/NotFound";


import VendorView from "./Components/Vendor/View/VendorView";

import Supplier360 from "./Components/Vendor/View/Drilldown/Supplier360";

import DashboardFinal from "./Components/dashboard_final/DashboardFinal";

//New
import {
  updateActivity,
  isSessionExpired,
  logout,
} from "./Utils/SessionManager";


//New

function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Restore session when opening VMS in another browser tab
  // if (sessionStorage.getItem("isLoggedIn") !== "true") {
  //   const sharedSession = localStorage.getItem("vmsSessionData");

  //   if (sharedSession) {
  //     try {
  //       const sessionData = JSON.parse(sharedSession);

  //       Object.keys(sessionData).forEach((key) => {
  //         sessionStorage.setItem(key, sessionData[key]);
  //       });
  //     } catch (error) {
  //       console.error("Failed to restore shared session:", error);
  //     }
  //   }
  // }

  // ==========================================
  // 1 HOUR INACTIVITY - UPDATE LAST ACTIVITY
  // ==========================================
  useEffect(() => {
    const handleActivity = () => {
      if (sessionStorage.getItem("isLoggedIn") === "true") {
        updateActivity();
      }
    };

    window.addEventListener("click", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("scroll", handleActivity);

    return () => {
      window.removeEventListener("click", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("scroll", handleActivity);
    };
  }, []);

  const isLoginPage =
    location.pathname === "/login" || location.pathname === "/";

  // ==========================================
  // CHECK SESSION EVERY 1 MINUTE
  // ==========================================
  useEffect(() => {
    const checkSession = () => {
      const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";

      // Don't check session on login page
      if (isLoginPage || !isLoggedIn) {
        return;
      }

      // Check if user has been inactive for 1 hour
      if (isSessionExpired()) {
        //alert("Your session has expired. Please login again.");
        logout();
      }
    };

    // Check immediately
    checkSession();

    // Check every 1 minute
    const interval = setInterval(checkSession, 60 * 1000);

    // Check when user returns to browser/tab
    const handleFocus = () => {
      checkSession();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", handleFocus);
    };
  }, [isLoginPage]);

  const handleSidebarCollapse = useCallback((collapsed) => {
    setSidebarCollapsed(collapsed);
  }, []);

  const handleSidebarToggle = useCallback(() => {
    setSidebarCollapsed((collapsed) => !collapsed);
  }, []);

  // useEffect(() => {
  //   const handleStorageChange = (event) => {
  //     if (event.key === "vmsSession") {
  //       if (event.newValue !== "true") {
  //         sessionStorage.clear();
  //         navigate("/login", { replace: true });
  //       }
  //     }
  //   };

  //   window.addEventListener("storage", handleStorageChange);

  //   return () => {
  //     window.removeEventListener("storage", handleStorageChange);
  //   };
  // }, [navigate]);

  return (
    <div
      className={`app-container ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}
    >
      <Sidebar
        collapsed={sidebarCollapsed}
        onCollapsedChange={handleSidebarCollapse}
      />
      <Navbar
        sidebarCollapsed={sidebarCollapsed}
        onSidebarToggle={handleSidebarToggle}
      />

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" />} />

          {/* ERP Entry Point */}
  <Route path="/Sidebar" element={<Sidebar />} />


        <Route element={<AppLayout />}>
          {/* <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          /> */}

          <Route
            path="/Dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* <Route
            path="/home1"
            element={
              <ProtectedRoute>
                <Home1/>
              </ProtectedRoute>
            }
          />  */}

          <Route
            path="/Dashboard2"
            element={
              <ProtectedRoute>
                <Dashboard2 />
              </ProtectedRoute>
            }
          />

          <Route
            path="/CategoryManager"
            element={
              <ProtectedRoute>
                <CategoryManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ReligionManager"
            element={
              <ProtectedRoute>
                <ReligionManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/RegionManager"
            element={
              <ProtectedRoute>
                <RegionManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/HolidayManager"
            element={
              <ProtectedRoute>
                <HolidayManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TemplateMaster"
            element={
              <ProtectedRoute>
                <TemplateMaster />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Registration"
            element={
              <ProtectedRoute>
                <Registration />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/contact"
            element={
              <ProtectedRoute>
                <Contact />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/Invitation"
            element={
              <ProtectedRoute>
                <Invitation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/UserGroup"
            element={
              <ProtectedRoute>
                <Group />
              </ProtectedRoute>
            }
          />
          <Route
            path="/UserMapping"
            element={
              <ProtectedRoute>
                <UsrMap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/RoleMapping"
            element={
              <ProtectedRoute>
                <RoleMap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Vendor_CardView"
            element={
              <ProtectedRoute>
                <VCard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Vendor_Status"
            element={
              <ProtectedRoute>
                <VStatus />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Card_Scan"
            element={
              <ProtectedRoute>
                <Cardscan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Business_Card"
            element={
              <ProtectedRoute>
                <BussinessC />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CustomMail"
            element={
              <ProtectedRoute>
                <CustomMail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/VendorApprovalStatus"
            element={
              <ProtectedRoute>
                <VendorApprovalStatus />
              </ProtectedRoute>
            }
          />

          <Route
            path="/EventManager"
            element={
              <ProtectedRoute>
                <EventManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/PrivateUserMaster"
            element={
              <ProtectedRoute>
                <PrivateUserMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Business_CardReport"
            element={
              <ProtectedRoute>
                <BusinessCardReport />
              </ProtectedRoute>
            }
          />

          <Route
            path="/VendorView"
            element={
              <ProtectedRoute>
                <VendorView />
              </ProtectedRoute>
            }
          />



          <Route
            path="/Supplier360"
            element={
              <ProtectedRoute>
               <Supplier360 />
              </ProtectedRoute>
            }
          />



           <Route
            path="/DashboardFinal"
            element={
              <ProtectedRoute>
               <DashboardFinal />
              </ProtectedRoute>
            }
          />


        
              

            
        </Route>
        {/* Invalid URL */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
